<template>
  <b-modal
      ref="show-modal"
      :title="$t('message.show_modal.title')"
      cancel-title="Close"
      ok-only
      size="lg"
      no-enforce-focus
  >
    <div class="row">
      <div class="col-12">
        <div v-if="isBusy" class="spinner-wrapper">
          <b-spinner></b-spinner>
        </div>

        <template v-if="!isBusy">
          <div class="h6 mb-4">
            {{ $t('messages.topic') }}: <b>{{ data && data.length ? data[0].topic : '' }}</b>
          </div>

          <div v-for="message in data" :key="message.id" class="row mb-4 p-3" :style="{ background: message.direction === 'from_player' ? '#dee2e6' : '' }">
            <div class="col-4 d-flex flex-column">

              <span class="text-primary text-bold">{{ message.senderName === 'operator' ? $t('messages.message_from_operator') : message.senderName }}</span>

              <span class="text-primary text-bold">{{ message.sentAt | dateTimeFormat }}</span>
            </div>
            <div class="col-8" v-html="message.contents"></div>
          </div>
        </template>
        <template v-if="message.type !== 'sms'">
          <div class="row">
            <div class="col-12">
              <b-form-group id="input-group-2" :label="$t('messages.email.topic')" label-for="topic">
                <b-form-input
                    id="topic"
                    v-model="topic"
                    disabled
                    :placeholder="$t('messages.email.topic.placeholder')"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-form-group
                  :label="$t('messages.email.content')"
                  label-for="slug"
                  class="mt-2">
                <div
                    :class="{
                    border: !$v.contents.$dirty ? null :($v.contents.$error),
                    'border-danger': !$v.contents.$dirty ? null :($v.contents.$error)}">
                  <editor
                      :apiKey="editorApiKey"
                      :init="{
                      height: 200,
                      plugins: editorPlugins,
                      toolbar: editorToolbar
                    }"
                      v-model="contents"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-end">
              <button :disabled="isRequest" @click="submit()" class="btn btn-success">{{ $t('btn.save_message') }}</button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import {required} from "vuelidate/lib/validators";
import {mapState} from "vuex";
//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  components: {
    'editor': Editor
  },
  props: {
    message: Object
  },
  data() {
    return {
      isRequest: false,
      isBusy: false,
      data: {},
      topic: null,
      contents: null,
      editorApiKey: '2a3y3y6ckc55ceyj8yvqoicrwnruvsf32dtctkkgop19qea3',
      editorPlugins: [
        'advlist autolink lists link image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table', 'code'
      ],
      editorToolbar: 'undo redo | formatselect | bold italic | \
        alignleft aligncenter alignright | \
        code bullist numlist outdent indent | help'
    };
  },
  computed: {
    ...mapState({
      userEmail: (state) => state.root.user.email
    })
  },
  validations: {
    contents: {
      required
    }
  },
  methods: {
    openModal() {
      this.isBusy = true;

      this.getMessages();

      this.$refs['show-modal'].show();
    },
    setMessageAsRead(id) {
      if(this.message.unreadCount > 0) {
        axios.post(`/api/inbox/set-as-read/thread/${id}`)
            .then(() => {
              this.$parent.$emit('refreshGrid');
            })
            .catch(err => {
              console.log('err', err);
            });
      }
    },
    getMessages() {
      axios.get(`/api/inbox/thread/${this.message.id}?sort[]=sentAt`)
        .then(resp => {
          this.setMessageAsRead(this.message.id);

          this.data = resp.data.items;
          this.topic = resp.data.items[0].topic
          this.isBusy = false;
        })
        .catch(err => {
          console.log('err', err);
        });
    },
    submit() {
      this.$v.$touch();

      const payload = {
        playerId: this.message.playerId,
        topic: this.topic,
        threadId: this.message.id,
        contents: this.contents
      }

      if(!this.$v.$invalid && !this.isRequest) {
        this.isRequest = true;

        axios.post(`/api/inbox/message-to-player/compose/inbox`,
            payload
        )
        .then(() => {
          this.getMessages();
          this.$v.$reset();
          this.topic = '';
          this.contents = '';
          this.isRequest = false;
        })
        .catch(() => {
          this.isRequest = false;
        });
      }
    },
  }
}
</script>
